import { AppBar, Avatar, Backdrop, Box, Button, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { followUser, getUserPosts, getUserProfile, unFollowUser } from '../../actions/profile';
import Posts from '../Posts/Posts';
import UserAvatar from '../UserAvatar/UserAvatar';
import styles from './styles';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import { useLayoutEffect } from 'react';
import LoadingIcon from '../Icons/LoadingIcon/LoadingIcon';
import ViewPost from '../ViewPost/ViewPost';
import theme from '../../muiTheme';
import { HiBadgeCheck } from "react-icons/hi";
import './styles.scss';
import FollowersView from './Followers/FollowersView';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
        >
        {value === index && (
            <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
            </Box>
        )}
        </div>
    );
}

  
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const ProfilePage = () => {

    const { authData } = useSelector((state) => state.authReducer);
    const socketStateSlice = useSelector((state) => state.socketsReducer);
    const {user, profileLoading, posts, currentPage, numberOfPages, userPostsLoading} = useSelector((state) => state.profileReducer);
    const [sameUser, setSameUser] = useState(false);
    const [profile, setProfile] = useState({});
    const {id} = useParams(); 
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const [dataFetched, setDataFetched] = useState(false);
    const [swiper, setSwiper] = useState(null); 
    const [value, setValue] = useState(0);
    const [selectedPost, setSelectedPost] = useState(null);
    const [bgGradient, setBgGradient] = useState(null);
    const [showFollowers, setShowFollowers] = useState(false);
    const dirURL = '/posts';
    let followButtonVariant = authData?.result ? (profile.invokerFollows ? 'hollow' : 'main' ) : 'faint';


    useEffect(()=>{

        console.log('AuthData: ', authData, 'dataFetched: ', dataFetched);

        if(dataFetched && id === profile._id){

            return; 

        }

        if(id){

            setProfile({});

            
            dispatch(getUserPosts(id));
            setDataFetched(true);

            if(authData?.result){

                dispatch(getUserProfile(id, authData?.result._id));
                setSameUser(authData?.result._id === id);
            }else{
                setSameUser(false);
                dispatch(getUserProfile(id));
            }

        }else if(authData?.result) {

            //get current user's profile
            setProfile({});
            dispatch(getUserProfile(authData.result._id));
            dispatch(getUserPosts(authData.result._id));
            setSameUser(true);

            setDataFetched(true);
        }else {

            //navigate back to home
            //navigate('/');
        }

    }, [id, authData]);

    useEffect(()=>{

        console.log('user changed: ', user);

        //set showFollowers to false
        setShowFollowers(false);

        //set profile
        setProfile(user);

        if(user.profileBackgroundAV){
            let bgAv = 'linear-gradient(to right, #b24592, #f15f79)'; 
            let avColors = JSON.parse(user.profileBackgroundAV) || null; 

            bgAv = avColors ? `linear-gradient(to right, ${avColors.avColor1}, ${avColors.avColor2})` : bgAv; 
            setBgGradient(bgAv);
            console.log('profile background av: ', user.profileBackgroundAV);
        }

    }, [user]);

    useEffect(()=>{

        return () => {
            setProfile({});
        };
    }, []);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);

        console.log('Tab changed, value: ', newValue, ' swiper: ', swiper);

        if(swiper){
            swiper.slideTo(newValue);
        }
        
    };

    const handleTabChangeIndex = (index) => {
        setValue(index);
    };


    const handleOverlayClick = (event) => {

        

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('popup-overlay')){
            //remove post id from url
            const origin = window.location.origin; 
            window.history.pushState({},'',origin+dirURL); 

            //set selected post to null
            setSelectedPost(null); 
        }
    }


    const handlePostClick = (post) => {


        console.log('handle post click triggered');
        //this function on gets invoked on non-mobile devices

        //changing url without reload:

        const url = new URL(window.location); 

        //TODO: remove previous post id if present

        //update url
        window.history.pushState({},'',url+'/'+post._id); 

        setSelectedPost(post);
 
    }

    const handleFollowUser = () => {


        dispatch(followUser(authData.result._id, id));
    }

    const handleUnFollowUser = () => {


        dispatch(unFollowUser(authData.result._id, id));
    }

    const toggleShowFollowers = (index) => {


        setShowFollowers(prevValue => !prevValue); 
    }

    const handleFollowersOverlayClick = (event) => {

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('followers-overlay')){

            setShowFollowers(false);
        }
    }


    if(profileLoading){
    

        return <Box

                    sx={{
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}  
        
                >
                    <LoadingIcon />
                </Box>

    }

    return (

        <>
        <Box
            sx={{...styles.rootContainer, background: profile.profileBackgroundImage ? 'white' : 'linear-gradient(to right, #b24592, #f15f79)' }}
        >

                {
                    profile.profileBackgroundImage &&

                    <>

                        {/* <img 
                            className='backdrop-blur'
                            src={profile.profileBackgroundImage} 
                            style={styles.backgroundImageBlur} 
                        
                        /> */}
                    
                    
                        <Box
                            sx={styles.backgroundImageContainer}
                        >
                            <img 
                                src={profile.profileBackgroundImage} 
                                style={styles.backgroundImage} 
                            
                            />

                        </Box>

                        {
                           (profile.profileQuote && profile.profileQuote.length > 0 ) &&

                            <Box
                                sx={styles.backgroundQuoteContainer}
                            >

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'flex-start',
                                        padding: '50px',
                                        borderRadius: '20px',
                                        background: '#00000036',
                                        backdropFilter: 'blur(10px)',
                                        color: 'white',
                                        [theme.breakpoints.down('sm')]: {
                                            padding: '20px'
                                        }
                                    }}
                                >
                                    <Typography variant='logo' sx={{fontSize: '32px'}}>
                                        My Quote
                                    </Typography>

                                    <Divider sx={{
                                        width: '50%', 
                                        borderColor: '#ffffff82', 
                                        marginY: '20px',
                                        [theme.breakpoints.down('sm')]: {
                                            marginY: '10px'
                                        }
                                        
                                    }} />

                                    <Typography variant='body2' sx={styles.backgroundQuote}>
                                        {`"${profile.profileQuote}"`}
                                    </Typography>

                                    <Typography variant='logo' sx={{fontSize: '32px', alignSelf: 'flex-end'}}>
                                        {`- ${profile.name}`}
                                    </Typography>
                                </Box>
                                
                            </Box>
                        }
                        
                        
                    </>
                }

            <Box

                sx={{
                    ...styles.headerContainer,
                   
                }}
            
            >
                

                <Box
                
                    sx={styles.headerInfoContainer}
                >

                    <Box
                        sx={styles.innerHeaderInfoContainer}
                    >

                        <Box
                            sx={styles.headerInfo}
                        >
                            <Box
                            
                                sx={styles.headerAvatarContainer}
                            >

                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '100%',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <img src={profile.profileImage} style={styles.userAvatar}/>

                                    {
                                        sameUser ?

                                        <Button onClick={()=>navigate('/profile/edit')} variant='faint' sx={{margin: '10px'}}>
                                            Edit
                                        </Button>

                                        :

                                        <Button 
                                            variant={followButtonVariant} 
                                            disabled={authData?.result ? false : true} 
                                            sx={{
                                                margin: '10px',
                                            }}
                                            
                                            onClick={profile.invokerFollows ? handleUnFollowUser : handleFollowUser}
                                            
                                            >
                                            {profile.invokerFollows ? 'Following' : 'Follow'}
                                        </Button>

                                    }
                                </Box>
                                

                                <Typography variant='h6' sx={{display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-evenly'}}>
                                    {profile.name} 
                                    
                                    {
                                        profile.verified &&

                                        <HiBadgeCheck style={{marginLeft: '5px'}}/>
                                    }
                                    
                                </Typography>

                                {
                                    profile.followsInvoker && 

                                    <Typography 
                                        variant='body2' 
                                        sx={styles.followNotification}
                                    >
                                        Follows You
                                    </Typography>

                                }

                                <Typography variant='body1' sx={{marginTop: '10px'}}>
                                    {profile.bio}
                                </Typography>
                            </Box>


                            <Box
                                sx={styles.headerDetailsContainer}
                            >

                                <Box
                                
                                    sx={styles.headerDetails}
                                >

                                    <Typography variant='body1' sx={{marginRight: '20px', fontWeight: '500'}}>
                                        {profile.location} 
                                    </Typography>

                                    <a target='_blank' rel='noreferrer' href={user.website}>
                                        <Typography variant='body1' sx={{marginRight: '20px', fontWeight: '500'}}>
                                            {profile.website}
                                        </Typography>
                                    
                                    </a>
                                    
                                </Box>


                                <Box
                            
                                    sx={styles.headerFollowMetrics}
                                >

                                    <Typography 
                                        variant='body1' 
                                        sx={{
                                            marginRight: '20px', 
                                            fontWeight: '500', 
                                            display: 'flex', 
                                            flexDirection: 'row', 
                                            alignItems: 'center'}}
                                        onClick={toggleShowFollowers}
                                        >
                                        <Typography variant='h6' sx={{marginRight: '5px'}}>{profile.followingCount}</Typography> Following
                                    </Typography>

                                    <Typography 
                                        variant='body1' 
                                        sx={{
                                            marginRight: '20px', 
                                            fontWeight: '500', 
                                            display: 'flex', 
                                            flexDirection: 'row', 
                                            alignItems: 'center'}}
                                        onClick={toggleShowFollowers}
                                        >

                                        <Typography variant='h6' sx={{marginRight: '5px'}}>{profile.followerCount}</Typography> Followers
                                    </Typography>

                                    
                                </Box>
                            </Box>

                            
                        </Box>                        

                    </Box>

                    <Divider sx={{width: '60%', margin: '10px'}}/>

                </Box>

                <Box
                    sx={styles.tabsContainer}
                >

                    <img src={profile.profileImage} alt='profileimage' style={styles.tabsAvatar}/> 

                    
                    <Tabs
                        value={value}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="Posts" {...a11yProps(0)} />
                        <Tab label="Media" {...a11yProps(1)} />
                        <Tab label="Likes" {...a11yProps(2)} />
                    </Tabs>
                    
                </Box>

            </Box>
            
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    background: theme.palette.background.container,
                    zIndex: '2'
                }}
            >

            
                <Box
                    sx={styles.swiperContainer}
                >

                    <Swiper

                        className='profile-swiper'
                        style={styles.profileSwiper}
                        onSlideChange={(swiperObj) => setValue(swiperObj.realIndex) }
                        onSwiper={setSwiper}
                    >

                        <SwiperSlide
                            style={styles.swiperSlide}
                        >

                            <Box
                                sx={styles.swiperSlideContentBox}
                            >

                                <Posts
                            
                                    currentId={profile._id} 
                                    disableDefaultPostClick={true}
                                    onPostClick={handlePostClick}
                                    posts={posts} 
                                    isLoading={userPostsLoading} 
                                    setCurrentId={()=>{}}
                                >
                                    
                                </Posts>

                            </Box>

                            

                            
                        </SwiperSlide>

                        <SwiperSlide
                            style={styles.swiperSlide}
                        >
                            <Box
                                sx={styles.swiperSlideContentBox}
                            >

                                <Typography>
                                    Comming Soon!
                                </Typography>

                            </Box>
                        
                        </SwiperSlide>

                        <SwiperSlide
                            style={styles.swiperSlide}
                        >
                            
                            <Box
                                sx={styles.swiperSlideContentBox}
                            >

                                <Typography>
                                    Comming Soon!
                                </Typography>

                            </Box>
                        </SwiperSlide>

                    </Swiper>

                    
                </Box>
            </Box>
        </Box>


        <Backdrop
            open={selectedPost !== null}
            sx={styles.popUpOverlay}
        >

            
                
                <Box
                    className='popup-overlay'
                    sx={styles.popUpBox}
                    onClick={handleOverlayClick} 
                >
                    { selectedPost && 
                        <ViewPost post={selectedPost}  />
                    }
                    
                </Box>
                    
                        
                
                
                
            

        </Backdrop>

        <Backdrop
            className='followers-overlay'
            open={showFollowers}
            sx={{...styles.popUpOverlay, zIndex: '500'}}
            onClick={handleFollowersOverlayClick}
        >
            
            {
                showFollowers && 

                <FollowersView profile={profile} onClose={()=>setShowFollowers(false)}/>
            }
            

        </Backdrop>

        </>
    ); 
}

export default ProfilePage; 